import { render, staticRenderFns } from "./CareProduct.vue?vue&type=template&id=fb0c514e"
import script from "./CareProduct.vue?vue&type=script&lang=js"
export * from "./CareProduct.vue?vue&type=script&lang=js"
import style0 from "./CareProduct.vue?vue&type=style&index=0&id=fb0c514e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports